
        <div class="footer">
            <p class="copyright">Copyright © 2021 <strong class="theme-text-color">Crypto Exchange & QTE Token</strong> All Rights Reserved.</p>
        </div>

